import { Pipe, PipeTransform } from '@angular/core';
import { InvoiceStatus } from '@services';

@Pipe({
    name: 'invoiceStatus',
    standalone: true,
})
export class InvoiceStatusPipe implements PipeTransform {
    transform(value: InvoiceStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case InvoiceStatus.OnHold: return 'On Hold';
            case InvoiceStatus.L1Approval: return 'L1 Approval';
            case InvoiceStatus.L2Approval: return 'L2 Approval';
            case InvoiceStatus.L3Approval: return 'L3 Approval';
            case InvoiceStatus.PendingAP: return 'Pending AP';
            default:
                return value;
        }
    }
}